import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function PurchaseSection() {
  return <section id="comprar" className="py-14 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-76">
      <div className="max-w-4xl mx-auto" data-id="element-77">
        <div className="bg-brand-purple rounded-3xl shadow-2xl overflow-hidden border-4 border-brand-roseGold/30" data-id="element-78">
          <div className="p-6 sm:p-10 text-center text-white" data-id="element-79">
            <h2 className="text-3xl sm:text-4xl font-serif font-bold mb-6" data-id="element-80">
              Empezá a gestionar tu clínica como una profesional hoy mismo
            </h2>

            <p className="text-brand-roseLight text-lg mb-8" data-id="element-81">
              Acceso inmediato al Sistema de Gestión Clínica de Uñas Premium +
              Los 4 Bonos Exclusivos
            </p>

            <div className="bg-white/10 rounded-2xl p-6 mb-6 backdrop-blur-sm border border-white/20" data-id="element-82">
              <div className="flex flex-col items-center justify-center" data-id="element-83">
                <span className="text-gray-300 text-xl line-through mb-2" data-id="element-84">
                  Precio Normal: $49.990
                </span>
                <div className="flex items-start justify-center" data-id="element-85">
                  <span className="text-3xl font-bold text-brand-gold mt-2" data-id="element-86">
                    $
                  </span>
                  <span className="text-7xl font-black text-brand-gold tracking-tight" data-id="element-87">
                    19.990
                  </span>
                  <span className="text-xl text-brand-gold mt-8 ml-2" data-id="element-88">ARS</span>
                </div>
                <div className="mt-4 inline-block bg-green-500 text-white text-sm font-bold px-4 py-1 rounded-full" data-id="element-89">
                  Ahorrás $30.000 (60% OFF)
                </div>
              </div>
            </div>

            <a href="https://checkout.infodigitalcore.shop/cart/49074661556463:1" className="block w-full sm:w-auto mx-auto max-w-md px-8 py-5 bg-gradient-to-r from-brand-gold to-yellow-500 hover:from-yellow-500 hover:to-brand-gold text-brand-purple rounded-xl font-black text-xl sm:text-2xl transition-all transform hover:scale-105 shadow-[0_0_30px_rgba(212,175,55,0.4)] uppercase tracking-wide" data-id="element-90">
              COMPRAR AHORA
            </a>

            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-8 text-sm text-brand-roseLight" data-id="element-91">
              <div className="flex items-center" data-id="element-92">
                <Lock className="w-4 h-4 mr-2" data-id="element-93" />
                Pago 100% Seguro
              </div>
              <div className="flex items-center" data-id="element-94">
                <CreditCard className="w-4 h-4 mr-2" data-id="element-95" />
                Todos los medios de pago
              </div>
            </div>
          </div>

          <div className="bg-brand-cream p-6 text-center border-t border-brand-roseGold/20" data-id="element-96">
            <div className="flex justify-center mb-4" data-id="element-97">
              <ShieldCheck className="w-16 h-16 text-brand-purple" data-id="element-98" />
            </div>
            <h3 className="text-xl font-bold text-brand-purple mb-2" data-id="element-99">
              Garantía de Satisfacción Total de 7 Días
            </h3>
            <p className="text-gray-600 text-sm max-w-2xl mx-auto" data-id="element-100">
              Estamos tan seguros de que este sistema va a transformar tu
              clínica que te damos 7 días para probarlo. Si sentís que no es
              para vos, te devolvemos el 100% de tu dinero sin hacer preguntas.
              El riesgo es todo nuestro.
            </p>
          </div>
        </div>
      </div>
    </section>;
}